import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// Firebase
import { firestore as db, logvisita } from "./firebaseConfig"; 
import { doc, getDoc } from 'firebase/firestore';
// Componentes
import Layout from './components/Layout';
import Home from './components/Home';
import Contato from './components/Contato';
import QuemSomos from './components/QuemSomos';
import Painel from './components/Painel';
import Login from './components/Login';
import Mercado from './components/MercadoFinanceiro';
import Agro5 from './components/Agro5';
import Anunciar from './components/Anunciar';
import MeusAnuncios from './components/MeusAnuncios';
import MinhaConta from './components/MinhaConta';
import Favoritos from './components/Favoritos';
import Configuracoes from './components/Configuracoes';
import AuthModal from './components/AuthModal';
import Lpdominio from './components/Lpdominio';

const App = () => {
  const [domainInfo, setDomainInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const mainDomain = 'vedo.com.br';
  const hostname = window.location.hostname;
  const normalizedHost = hostname.replace(/^www\./, '');

  const contactInfo = {
    email: 'dominios@af3.com.br',
    telefone: '+55 (11) 97432-2795'
  };

  useEffect(() => {
    logvisita();
    if (normalizedHost !== mainDomain && normalizedHost !== 'localhost') {
      const fetchDomainData = async () => {
        setLoading(true);
        try {
          const docRef = doc(db, 'dominios', normalizedHost);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setDomainInfo(docSnap.data());
          } else {
            const defaultDocRef = doc(db, 'dominios', 'default');
            const defaultDocSnap = await getDoc(defaultDocRef);
            if (defaultDocSnap.exists()) {
              setDomainInfo(defaultDocSnap.data());
            }
          }
        } catch (error) {
          console.error("Erro ao buscar dados do domínio:", error);
        }
        setLoading(false);
      };
      fetchDomainData();
    } else {
      setLoading(false);
    }
  }, [normalizedHost]);

  const openAuthModal = () => setShowAuthModal(true);

  if (normalizedHost === mainDomain || normalizedHost === 'localhost') {
    return (
      <Router>
        {showAuthModal && (
          <AuthModal
            onClose={() => setShowAuthModal(false)}
            onSuccess={() => setShowAuthModal(false)}
          />
        )}

        <Layout onLoginClick={openAuthModal}>
          <Routes>
            <Route path="/"                     element={<Home />} />
            <Route path="/QuemSomos"            element={<QuemSomos />} />
            <Route path="/Contato/:dominioNome" element={<Contato />} />
            <Route path="/Login"                element={<Login />} />
            <Route path="/Painel"               element={<Painel />} />
            <Route path="/MercadoFinanceiro"    element={<Mercado />} />
            <Route path="/Agro5"                element={<Agro5 />} />
            <Route path="/Anunciar"             element={<Anunciar />} />
            <Route path="/Meusanuncios"         element={<MeusAnuncios />} />
            <Route path="/minha-conta"         element={<MinhaConta />} />
            <Route path="/Favoritos"         element={<Favoritos />} />
            <Route path="/Configuracoes"         element={<Configuracoes />} />
            <Route path="*"                     element={<Home />} />
          </Routes>
        </Layout>
      </Router>
    );
  }

  if (loading) {
    return <div style={{ backgroundColor: '#121212', minHeight: '100vh' }} />;
  }

  return (
    <Lpdominio
      {...domainInfo}
      {...contactInfo}
    />
  );
};

export default App;
